import{View}from'./View';/**
 * An abstract visual Calendar
 */export class VizGraphicIdProperty extends View{}